import { LocationUtilities } from './utils';
const countryCodeSelector = function () {
  jQuery('.animate-form-wrapper').addClass('overflow-visible');
  jQuery('body').addClass('hidden-x');
  jQuery('.dropdown-select-input.-country.phone-form').focus(function () {
    if (window.getSelection) {
      if (window.getSelection().empty) {  // Chrome
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {  // Firefox
        window.getSelection().removeAllRanges();
      }
    } else if (document.selection) {  // IE?
      document.selection.empty();
    }
    this.setSelectionRange(20, 21);
  });
  var phoneCodesEndpoint = `/static-assets/resources/freshdesk/phone-codes.json`;
  jQuery.getJSON(phoneCodesEndpoint, function (json) {
    constructMenu(json, 'cc_selector_ul');
  });
  function constructMenu (obj, menuid) {
    var ccGeolocation = setSelected(obj);
    var selectMenu = document.getElementById(menuid);
    var list = '';
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        var countryName = obj[key]['country'];
        var countryCode = obj[key]['code'];
        if (typeof countryName === 'undefined') {
          continue;
        }
        var selected = (ccGeolocation === key) ? 'selected = selected' : '';
        list += '<li class="option" phone-country-code="' + obj[key]['code'] + '" data-country-code= "' + key + '" ' + selected + '><i class="flag flag-' + key + '"></i><span>' + countryName + ' (' + countryCode + ')</span></li>';
      }
    }
    list += '<li class="option error"><i></i><span>No matches found!</span></li>';
    selectMenu.innerHTML = list;
    // set default selected country name and flag to dropdown input
    var setSelectedCountry = jQuery('#cc-flag');
    var updateCurrInputValue = jQuery('.fworks-custom-dropdown .dropdown-select-input.-country');
    if (typeof ccGeolocation !== 'undefined') {
      setSelectedCountry.attr('data-iso-code', ccGeolocation);
      setSelectedCountry.attr('phone-country-code', obj[ccGeolocation]['code']);
      setSelectedCountry.attr('class', 'dropdown-select-input flag flag-' + ccGeolocation);
      updateCurrInputValue.val(obj[ccGeolocation]['code']);
    }
  }
  function setSelected (obj) {
    var currentLocation;
    LocationUtilities.onLocationReady(function (geoLocation) {
      currentLocation = geoLocation.country.iso_code;
    });
    return (currentLocation in obj) ? currentLocation : 'US';
  }
};

export { countryCodeSelector };
